import { T } from "@classdojo/web";
import { BodyText, LabelText } from "@classdojo/web/nessie";
import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import blueDiscussCloud from "src/pods/ideas/assets/blueDiscussCloud.svg";

type DiscussProps = {
  topic: string;
  onClick: VoidFunction;
};

export default function Discuss({ topic, onClick }: DiscussProps) {
  return (
    <div sx={lessonCardDiscussStyle} onClick={onClick}>
      <div sx={lessonCardDiscussDivStyle}>
        <BodyText level={2} kind="tertiary" sx={lessonCardDiscussDivPStyle}>
          {topic}
        </BodyText>
        <div sx={lessonCardDiscussDivPH5Style}>
          <img sx={lessonCardDiscussDivPH5ImgStyle} src={blueDiscussCloud} alt="Discuss" />
          <LabelText level={2} kind="accent">
            <T str="dojo.toolkit:discuss.think_pair_share" fallback="Think Pair Share" />
          </LabelText>
        </div>
      </div>
      {false && (
        <div sx={lessonCardDiscussCloudStyle}>
          <img sx={lessonCardDiscussCloudImgStyle} src={blueDiscussCloud} alt="Discuss" />
        </div>
      )}
    </div>
  );
}

const lessonCardDiscussStyle: ThemeUIStyleObject = {
  minHeight: "100px",
  width: "100%",
  borderRadius: "dt_radius_s",
  padding: RAW_cssValue("20px"),
  margin: RAW_cssValue("10px"),
  fontSize: "16px",
  color: "dt_content_secondary",
  display: "flex",
  flex: 1,
  flexDirection: "column",
  cursor: "pointer",
  boxShadow: RAW_cssValue("0 8px 16px 0 rgba(0, 0, 0, 0.05) !important"),
  "@media (max-width: 320px)": {
    width: "160px",
    flex: "1 1 auto",
  },
  "@media (max-width: 375px)": {
    width: "160px",
    flex: "1 1 auto",
  },
  "@media (max-width: 414px)": {
    width: "150px",
    flex: "1 1 auto",
  },
  "@media (max-width: 768px)": {
    width: "180px",
    flex: "1 1 auto",
  },
};

const lessonCardDiscussDivStyle: ThemeUIStyleObject = {
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  flex: 1,
};

const lessonCardDiscussDivPStyle: ThemeUIStyleObject = {
  marginBottom: "dt_m",
};

const lessonCardDiscussDivPH5Style: ThemeUIStyleObject = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "auto",
};

const lessonCardDiscussDivPH5ImgStyle: ThemeUIStyleObject = {
  width: "16px",
  height: "16px",
  backgroundSize: "16px 16px",
  marginRight: RAW_cssValue("5px"),
};

const lessonCardDiscussCloudStyle: ThemeUIStyleObject = {
  backgroundColor: "dt_content_accent",
  borderRadius: "dt_radius_s",
  marginTop: "auto",
  width: "35px",
  height: "35px",
  padding: RAW_cssValue("5px"),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const lessonCardDiscussCloudImgStyle: ThemeUIStyleObject = {
  backgroundSize: "20px 20px",
  width: "20px",
  height: "20px",
};
